
<template>
<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">

<path class="st0" d="M271.4,225.2c-3.8-2.3-7.2-4.5-10.7-6.4c-18.5-10.6-38.3-12.7-59.1-9c-16.5,3.4-32.7,8.2-48.4,14.5
	c-17.1,6.3-34.2,12.9-52.2,16.4c-16.4,3.7-33.5,2.8-49.4-2.7c-7.8-2.8-15.1-6.7-21.7-11.8c-0.6-0.7-1.1-1.6-1.3-2.5
	c-0.1-0.6-0.1-1.3,0-2c0-47.7,0-95.4,0-143.1c0-1.1,0-2.2,0-3.8c3.7,2.3,6.7,4.4,10.1,6.4c16.7,9.5,36.2,13,55.1,9.9
	c15.9-2.7,31.5-7.1,46.4-13.1c20-7.2,39.6-15.3,60.6-19.1c17.6-3,35-2.7,51.6,4.9c6,2.8,11.8,6.5,17.6,9.9c0.6,0.6,1.1,1.4,1.3,2.2
	c0.1,0.5,0.1,0.9,0,1.4c0,48.3,0,96.5,0,144.8L271.4,225.2L271.4,225.2z"/>
<path class="st1" d="M271.4,217.9c-3.8-4-7.2-7.6-10.7-11c-18.5-18-38.3-21.5-59.1-15.3c-16.5,5.7-32.7,13.9-48.4,24.6
	c-17.1,10.7-34.2,21.9-52.2,27.9c-16.4,6.3-33.5,4.7-49.4-4.6c-7.8-4.7-15.1-11.4-21.7-20c-0.6-1.2-1.1-2.6-1.3-4.2
	c-0.1-1.1-0.1-2.2,0-3.3c0-81,0-40.4,0-121.4c0-1.8,0-3.7,0-6.5c3.7,3.9,6.7,7.4,10.1,10.8c16.7,16.2,36.2,22.1,55.1,16.8
	c15.9-4.6,31.5-12,46.4-22.2c20-12.3,39.6-26,60.6-32.4c17.6-5.1,35-4.6,51.6,8.3c6,4.7,11.8,11.1,17.6,16.9c0.6,1,1.1,2.3,1.3,3.7
	c0.1,0.8,0.1,1.6,0,2.4c0,81.9,0,42.3,0,124.2v5.1L271.4,217.9z"/>
</svg>

</template>

<script>
export default {
    name: 'IconFlag',
}
</script>

<style lang="scss" scoped>
</style>